import React, { useState, useEffect, useContext } from 'react';
import Checkbox from '../../../Checkbox/Checkbox';
import './RoverFilter.scss';
import { FilterStore } from '../../../../App';


export default () => {
  const currentFilter = useContext(FilterStore).filter;


  const [rovers, setRovers] = useState({
    Curiosity: currentFilter.rovers ? currentFilter.rovers.includes('Curiosity') : false,
    Spirit: currentFilter.rovers ? currentFilter.rovers.includes('Spirit') : false,
    Opportunity: currentFilter.rovers ? currentFilter.rovers.includes('Opportunity') : false,
    Perseverance: currentFilter.rovers ? currentFilter.rovers.includes('Perseverance') : false,
  });

  const { changeRovers } = useContext(FilterStore).actions;

  const onChange = (key, value) => {
    setRovers({
      ...rovers,
      [key]: value
    })
  }

  useEffect(() => {
    const filteredRovers = Object.entries(rovers)
      .filter(([_, value]) => value)
      .map(([rover]) => rover);
    
    changeRovers(filteredRovers);
  }, [rovers]);

  return (
    <div className="filter-item">
      <h2 className="filter-item__headline">Rover</h2>
      <div className="rover-select">
        <Checkbox
          checked={rovers['Curiosity']}
          onChange={(e) => onChange('Curiosity', e.target.checked)}
        >
          Curiosity
        </Checkbox>
        <Checkbox
          checked={rovers['Spirit']}
          onChange={(e) => onChange('Spirit', e.target.checked)}
        >
          Spirit
        </Checkbox>
        <Checkbox
          checked={rovers['Opportunity']}
          onChange={(e) => onChange('Opportunity', e.target.checked)}
        >
          Opportunity
        </Checkbox>
        <Checkbox
          checked={rovers['Perseverance']}
          onChange={(e) => onChange('Perseverance', e.target.checked)}
        >
          Perseverance
        </Checkbox>
      </div>
    </div>
  )
}